import { BORDER_CITIES_BY_STATE, BORDER_STATES } from '../../constants/constants';

export const TEMPLATE_OPTIONS = {
  news: [
    { value: 'news_tpl_1', label: 'Hero' },
    { value: 'news_tpl_2', label: 'Editorial' },
    { value: 'news_tpl_3', label: 'Report' },
  ],
  ad: [
    { value: 'ad_tpl_1', label: 'Banner + CTA' },
    { value: 'ad_tpl_2', label: 'Gallery' },
    { value: 'ad_tpl_3', label: 'Flyer' },
  ],
};

export const STATUS_FILTERS = [
  { label: 'In rotation', value: 'current' },
  { label: 'Live now', value: 'live' },
  { label: 'Scheduled', value: 'scheduled' },
  { label: 'Paused', value: 'paused' },
  { label: 'Expired', value: 'expired' },
  { label: 'Archived', value: 'archived' },
  { label: 'All', value: 'all' },
];

const STATE_NAMES = Object.fromEntries(
  (BORDER_STATES || []).map((state) => [state.code, state.name])
);

export function stateOptions() {
  return (BORDER_STATES || [])
    .filter((state) => state?.code && !state.disabled)
    .map((state) => ({
      value: state.code,
      label: state.name || state.code,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

export function cityOptions() {
  const options = [];
  Object.entries(BORDER_CITIES_BY_STATE || {}).forEach(([state, cities]) => {
    (cities || []).forEach((city) => {
      if (!city?.code || city.disabled) return;
      options.push({
        value: city.code,
        label: `${city.name} · ${STATE_NAMES[state] || state}`,
        cityName: city.name,
        stateCode: state,
        stateName: STATE_NAMES[state] || state,
      });
    });
  });
  options.sort((a, b) => a.label.localeCompare(b.label, 'es'));
  return options;
}

export function campaignStatus(item, now = new Date()) {
  if (item?.archived) return 'archived';
  if (item?.active === false) return 'paused';
  const end = item?.endsAt ? new Date(item.endsAt) : null;
  const start = item?.startsAt ? new Date(item.startsAt) : null;
  if (end && !Number.isNaN(end.getTime()) && end < now) return 'expired';
  if (start && !Number.isNaN(start.getTime()) && start > now) return 'scheduled';
  return 'live';
}

export function matchesCity(item, cityCode) {
  if (!cityCode) return true;
  const codes = item?.cityCodes || [];
  if (!codes.length) return true;
  return codes.includes(cityCode);
}

export function sortFeed(items) {
  return [...(items || [])].sort((a, b) => {
    const aPin = a?.isPinned && a?.type === 'news' ? 1 : 0;
    const bPin = b?.isPinned && b?.type === 'news' ? 1 : 0;
    if (aPin !== bPin) return bPin - aPin;
    const priority = (Number(a?.priority) || 0) - (Number(b?.priority) || 0);
    if (priority) return priority;
    return String(b?.createdAt || '').localeCompare(String(a?.createdAt || ''));
  });
}

export function packRows(items) {
  const rows = [];
  let index = 0;
  const list = items || [];
  while (index < list.length) {
    const item = list[index];
    const next = list[index + 1];
    if (item?.gridSpan === 'half' && next?.gridSpan === 'half') {
      rows.push([item, next]);
      index += 2;
    } else {
      rows.push([item]);
      index += 1;
    }
  }
  return rows;
}

export function excerpt(text, max = 96) {
  const plain = String(text || '')
    .replace(/\*\*/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (plain.length <= max) return plain;
  return `${plain.slice(0, max).trim()}…`;
}

export function toLocalInput(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function fromLocalInput(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}
